import Util from '../RegistrationUtil'
import Field from '../RegistrationField'

function DateField(opts) {
    this._altID = 'uid-' + Math.floor(Math.random() * 1000000)

    Field.call(this, opts)

    this.$input = this.$html.find('input[type="text"], input[type="date"]')
    this.$icon = this.$html.find('.svg-icon-wrap')
}

Util.inherit(DateField, Field, {
    getClassName: function() {
        return 'date'
    },

    buildHtml: function() {
        var html = ''
        if (this.registration.mobile) {
            html +=
                '<input id="' +
                this._altID +
                '" type="date" ' +
                this._getPlaceholderText() +
                ' "' +
                this._getAltText() +
                '" />'
        } else {
            html +=
                '<input id="' +
                this._altID +
                '" type="' +
                (this.registration.tablet ? 'date' : 'text') +
                '"' +
                ' ' +
                this._getPlaceholderText() +
                ' class="input" ' +
                this._getAltText() +
                ' />'
        }
        html += '<div class="svg-icon-wrap">' + this.registration.getSvg('calendar') + '</div>'
        return html
    },

    /**
     * Generate date from string, and handle timezone so user see correct date
     * typically we just add (GMT) to force it to not offset it by current timzone
     * firefox does not support this.
     */
    _dateFromString: function(dateString) {
        var d = new Date(dateString)
        //Ensur we are in the correct timezone
        d.setTime(d.getTime() + d.getTimezoneOffset() * 60 * 1000)
        if (isNaN(d)) {
            //If all fails give us avalid date.
            d = new Date(dateString)
        }
        return d
    },

    /**
     * Apply date to input field and date picker
     * @param  Date date
     */
    _applyDate: function(date) {
        this._savedMonthYear = date
        var formattedDate = date.toLocaleDateString('en-US')
        this.setValue(formattedDate)

        this.$input.datepicker('setDate', date)
        if (formattedDate != this.$input.val()) this.$input.val(formattedDate)

        if (!this.registration.mobile) {
            $('#registration-birthdate .field-content').addClass('date-selected')
        }
        this.$input.datepicker('hide')
        this.$input.blur()
    },

    applyBindings: function() {
        var self = this
        var _d = new Date()
        //Default to first of this month, 13 years ago
        this._savedMonthYear = this._dateFromString(_d.getFullYear() - 13 + '-' + (1 + _d.getMonth()) + '-01')
        var firstKeyStrokeRegistered = true

        if (this.registration.mobile || this.registration.tablet) {
            // MOBILE IS A SIMPLE DATEPICKER
            this.$input.change(function() {
                var value = $(this).val()
                self.setValue(value)
            })

            this.$input.on('focus', this.focus.bind(this))
            this.$input.on('blur', this.blur.bind(this))
            return
        }

        //if datepicker empty, hide component
        $(document).ready(function() {
            if ($('.ui-datepicker').html() == '') {
                $('.ui-datepicker').hide()
            }
        })

        this.$input
            .datepicker({
                // Custom property to make datepicker always appear below the input field.
                // See our custom override to the method _checkOffset below
                alwaysBelow: true,

                dateFormat: 'M d, yy',
                showOn: 'focus',
                buttonImageOnly: true,
                yearRange: 'c-100:c',
                changeMonth: true,
                changeYear: true,
                altField: '#' + this._altID,
                altFormat: 'yy-mm-dd',
                onSelect: function() {
                    self._applyDate(self._dateFromString(self.$input.val()))
                },
                onChangeMonthYear: function(year, month) {
                    self._savedMonthYear = self._dateFromString(year + '-' + month + '-01')
                },
                beforeShow: function(input, inst) {
                    // get position of icon relative to field container
                    var marginX
                    if (self.registration.mobile) {
                        // position the datepicker in center on field
                        marginX = self.$input.width() / 2
                    } else {
                        // position the datepicker over the icon
                        marginX = self.$icon.position().left + self.$icon.width() / 2
                    }

                    inst.dpDiv.css({
                        marginLeft: marginX + 'px',
                    })

                    return {
                        defaultDate: self._savedMonthYear,
                    }
                },
            })
            .on('keydown', function() {
                /**
                 * For some dumb reason this is required to ensure date sync between selector and field
                 */
                if (firstKeyStrokeRegistered) {
                    self.$input.datepicker('setDate', '')
                    firstKeyStrokeRegistered = false
                }
            })
            .on('change', function() {
                var value = self.$input.val()
                var d = new Date(Date.parse(value))
                self._applyDate(d)
                self.$input.blur()
            })
            .on('focus', this.focus.bind(this))
            .on('blur', this.blur.bind(this))
    },
})

// This is a hack to always show the datepicker popup below the input field.
//
// Source: http://stackoverflow.com/questions/1526500/getting-jquery-uis-datepicker-to-always-open-in-a-certain-direction
// (see comment by user "Purrell")
;(function() {
    var _super = $.datepicker._checkOffset
    $.extend($.datepicker, {
        _checkOffset: function(inst, offset, isFixed) {
            return inst.settings.alwaysBelow ? offset : _super.call(this, inst, offset, isFixed)
        },
    })
})()

export default DateField
